import downloadWorker from './download.worker'

class Lock {
  constructor() {
    this.isLocked = false
    this.waitQueue = []
  }

  lock() {
    return new Promise(resolve => {
      if (this.isLocked) {
        this.waitQueue.push(resolve)
      } else {
        this.isLocked = true
        resolve()
      }
    })
  }

  unlock() {
    if (this.waitQueue.length > 0) {
      const resolve = this.waitQueue.shift()
      resolve()
    } else {
      this.isLocked = false
    }
  }
}

/**
 * 下载锁
 */
const lockInstance = new Lock()

let worker = null

/**
 * 下载处理
 * @param {*} data
 */
export const downalod = async (downloadItem, onDownloadProgress) => {
  await lockInstance.lock()
  if (worker == null) {
    worker = new Worker(downloadWorker)
  }

  const result = new Promise((resolve, reject) => {
    // 监听函数
    const listener = e => {
      const [event, data] = e.data
      // 非本次下载任务不回调
      if (data.id !== downloadItem.id) return

      if (event === 'PROGRESS_UPDATE') {
        // 更新下载进度
        console.log('更新下载进度', data)
        // 下载进度更新
        onDownloadProgress(data)
      } else if (event === 'DOWNLOAD_COMPLETE') {
        // 下载完成
        console.log('下载完成', data)
        resolve(data)
        // 移除监听
        worker.removeEventListener('message', listener)
      } else if (event === 'DOWNLOAD_ERROR') {
        // 下载错误
        console.log('下载错误', data)
        reject(data)
        // 移除监听
        worker.removeEventListener('message', listener)
      } else if (event === 'DWONLOAD_ALL_COMPLETE') {
        console.log('下载全部完成', data)
        // 全部任务下载完成即关闭worker
        worker.terminate()
        // 重置worker
        worker = null
        // 下载失败
        resolve(data)
      }
    }

    // 监听下载进度
    worker.addEventListener('message', listener)
  })

  // 开始下载数据
  worker.postMessage(['DOWNLOAD', downloadItem])

  // 解锁
  lockInstance.unlock()

  // 返回下载结果
  return result
}



// WEBPACK FOOTER //
// ./src/worker/downloadUtil.js